import NumberInputView from './NumberInput.view';
export * from './NumberInput.view';

export const NumberInput = (props) => NumberInputView(props);

export default NumberInput;

